export const notComputableResults =
  "One or more results couldn't be computed (e.g. a division by zero). Check the formula or the inputs feeding it.";

export const notComputableRecalculate =
  "Recalculation couldn't compute some results (e.g. a division by zero) — check the formula and the inputs feeding it.";

export const notComputableCell =
  "This value couldn't be calculated — the formula produced an invalid result (e.g. a division by zero). Check the formula or the inputs feeding it.";

export const missingInputToggle =
  "Cannot mark as complete — enter all variable inputs first.";
